







































import { BadgeColor, GeekProfileBadge } from '@/models/geek-profile';
import { getPercentValue } from '@/utils';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'BadgesTab',
  data() {
    return {
      badgeColor: BadgeColor,
      loader: {
        isBadgesListPending: true,
      },
    };
  },
  async created() {
    try {
      await this.$store.dispatch(Actions.badges.fetchGeekBadges, this.$route.params.geekId);
    } finally {
      this.loader.isBadgesListPending = false;
    }
  },
  computed: {
    badges(): GeekProfileBadge[] {
      return typedStore(this).state.badges.geeksBadges;
    },
  },
  methods: {
    getCurrentLevelProgressPercents(badge: GeekProfileBadge): number {
      return getPercentValue(badge.activitiesCollectedForUpgrade, badge.activitiesNeededForUpgrade);
    },
    getTooltipText(badge: GeekProfileBadge): string {
      return this.$t(
        'geek-profile.badges-tab.tooltip',
        {
          amountToNextBadge:  badge.activitiesNeededForUpgrade - badge.activitiesCollectedForUpgrade,
          nextBadgeColor: this.getNextBadgeColor(badge).toLowerCase(),
        },
      ) as string;
    },
    getNextBadgeColor(badge: GeekProfileBadge): string {
      if (!badge.isFirstBadgeEarned) {
        return this.$t('geek-profile.badges-tab.badge-colors.bronze') as string;
      }
      switch (badge.badgeColor) {
        case this.badgeColor.Bronze:
          return this.$t('geek-profile.badges-tab.badge-colors.silver') as string;
        case this.badgeColor.Silver:
          return this.$t('geek-profile.badges-tab.badge-colors.gold') as string;
        default:
          return '';
      }
    },
    getBadgeDescriptionText(badge: GeekProfileBadge): string {
      return this.$t(
        `badge.types.${badge.name}.description`,
        {
          number:  badge.isFirstBadgeEarned
            ? badge.activitiesNeededForCurrentBadge
            : badge.activitiesNeededForUpgrade,
        },
      ) as string;
    },
  },
});
